import { DEFAULT_PALETTE } from "../../constants/palettes";
import React, { memo, useMemo } from 'react';
import { links as defaultLinks } from "./links";
import CompanyInfoSection from "./components/company-info-section";
import { Container } from "./styled-components";
import FooterContext from "./footer-context";
import { LAYOUT_TYPES } from "./constants";
import LinksColumns from "./components/links-columns";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Footer = function Footer(_ref) {
  var _ref$pageLocales = _ref.pageLocales,
    _pageLocales = _ref$pageLocales === void 0 ? [] : _ref$pageLocales,
    _ref$links = _ref.links,
    _links = _ref$links === void 0 ? defaultLinks : _ref$links,
    _ref$palette = _ref.palette,
    _palette = _ref$palette === void 0 ? DEFAULT_PALETTE : _ref$palette,
    _ref$layoutType = _ref.layoutType,
    _layoutType = _ref$layoutType === void 0 ? LAYOUT_TYPES.DEFAULT : _ref$layoutType,
    _ref$onLinkClick = _ref.onLinkClick,
    _onLinkClick = _ref$onLinkClick === void 0 ? function () {} : _ref$onLinkClick,
    _ref$onLinksAccordion = _ref.onLinksAccordionOpened,
    _onLinksAccordionOpened = _ref$onLinksAccordion === void 0 ? function () {} : _ref$onLinksAccordion,
    _ref$onCookiePolicySe = _ref.onCookiePolicySettingsClick,
    _onCookiePolicySettingsClick = _ref$onCookiePolicySe === void 0 ? function () {} : _ref$onCookiePolicySe,
    _ref$onLanguageSwitch = _ref.onLanguageSwitcherOptionClick,
    _onLanguageSwitcherOptionClick = _ref$onLanguageSwitch === void 0 ? function () {} : _ref$onLanguageSwitch;
  var isCompact = _layoutType === LAYOUT_TYPES.COMPACT;
  var providerValue = useMemo(function () {
    return {
      isCompact: isCompact,
      palette: _palette,
      links: _links,
      pageLocales: _pageLocales,
      layoutType: _layoutType,
      onLinkClick: _onLinkClick,
      onLinksAccordionOpened: _onLinksAccordionOpened,
      onCookiePolicySettingsClick: _onCookiePolicySettingsClick,
      onLanguageSwitcherOptionClick: _onLanguageSwitcherOptionClick
    };
  }, [isCompact, _layoutType, _links, _onCookiePolicySettingsClick, _onLanguageSwitcherOptionClick, _onLinkClick, _onLinksAccordionOpened, _pageLocales, _palette]);
  return /*#__PURE__*/_jsx(FooterContext.Provider, {
    value: providerValue,
    children: /*#__PURE__*/_jsxs(Container, {
      palette: _palette,
      children: [!isCompact && /*#__PURE__*/_jsx(LinksColumns, {}), /*#__PURE__*/_jsx(CompanyInfoSection, {})]
    })
  });
};
Footer.displayName = 'Footer';
export default /*#__PURE__*/memo(Footer);